import {
    CAN_NOT_CANCEL_BLOCKED_ACCOUNT,
    CAN_NOT_CANCEL_LEGAL_ACCOUNT,
    CAN_NOT_CANCEL_NEGATIVE_BALANCE_ACCOUNT,
    CAN_NOT_CANCEL_POSITIVE_BALANCE_ACCOUNT,
    CAN_NOT_CANCEL_RETENTION_ACCOUNT,
    UPDATE_PERSONAL_DATA_TO_TRANSFER_ACCOUNT,
    UPDATE_PERSONAL_ID_TO_TRANSFER_ACCOUNT,
    CAN_NOT_TRASFER_BLOCKED_ACCOUNT,
} from 'constants/tagging'

export const BLOCK_CASE = 'cancellation_account-account_blocked_alerts_descriptionKey'
export const LEGAL_CASE = 'cancellation_account-account_legal_validation_descriptionKey'
export const RETENTIONS_CASE = 'cancellation_account-account_balance_retentions_descriptionKey'
export const WITH_BALANCE_CASE = 'cancellation_account-account_balance_positive_descriptionKey'
export const NEGATIVE_BALANCE_CASE = 'cancellation_account-account_balance_negative_descriptionKey'
export const BLOCKED_ACCOUNT_TO_TRANSFER_CASE = 'transfer_account-account_blocked_validation_descriptionKey'
export const UPDATE_PERSONAL_DATA = 'transfer_account-account_fioc_validation_descriptionKey'
export const UPDATE_PERSONAL_ID = 'transfer_account-account_dni_validation_descriptionKey'


export const MODAL_VALIDATION_TAGGINGS = {
    [BLOCK_CASE]: {
        accionEvento: CAN_NOT_CANCEL_BLOCKED_ACCOUNT,
        component: `modal/${CAN_NOT_CANCEL_BLOCKED_ACCOUNT}`
    },
    [LEGAL_CASE]: {
        accionEvento: CAN_NOT_CANCEL_LEGAL_ACCOUNT,
        component: `modal/${CAN_NOT_CANCEL_LEGAL_ACCOUNT}`
    },
    [RETENTIONS_CASE]: {
        accionEvento: CAN_NOT_CANCEL_RETENTION_ACCOUNT,
        component: `modal/${CAN_NOT_CANCEL_RETENTION_ACCOUNT}`
    },
    [WITH_BALANCE_CASE]: {
        accionEvento: CAN_NOT_CANCEL_POSITIVE_BALANCE_ACCOUNT,
        component: `modal/${CAN_NOT_CANCEL_POSITIVE_BALANCE_ACCOUNT}`
    },
    [NEGATIVE_BALANCE_CASE]: {
        accionEvento: CAN_NOT_CANCEL_NEGATIVE_BALANCE_ACCOUNT,
        component: `modal/${CAN_NOT_CANCEL_NEGATIVE_BALANCE_ACCOUNT}`
    },
    [BLOCKED_ACCOUNT_TO_TRANSFER_CASE]: {
        accionEvento: CAN_NOT_TRASFER_BLOCKED_ACCOUNT,
        component: `modal/${CAN_NOT_TRASFER_BLOCKED_ACCOUNT}`
    },
    [UPDATE_PERSONAL_DATA]: {
        accionEvento: UPDATE_PERSONAL_DATA_TO_TRANSFER_ACCOUNT,
        component: `modal/${UPDATE_PERSONAL_DATA_TO_TRANSFER_ACCOUNT}`
    },
    [UPDATE_PERSONAL_ID]: {
        accionEvento: UPDATE_PERSONAL_ID_TO_TRANSFER_ACCOUNT,
        component: `modal/${UPDATE_PERSONAL_ID_TO_TRANSFER_ACCOUNT}`
    }
}
